module.exports = __webpack_public_path__ + "img/vip-bg.68c9cca1.jpg";